import React, {useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {
  Card,
  Typography,
  Button,
  MenuItem,
  Grid,
  TextField,
} from '@material-ui/core';
import * as yup from 'yup';
import { Formik } from 'formik';
import { addHelpTopicApi, editHelpTopicApi } from 'api/help';
import { BackdropCircular } from 'components';
import TopicContent from './TopicContent';


const TopicsForm = ({topic, setTopic}) => {
  const dispatch = useDispatch();
  const [content, setContent] = useState(topic.content || [{contentType: '', value: ''}]);
  const {helpCategories, helpSubCategories, isLoadingHelpSubCategories} = useSelector((state) => state.help);

  const handleChangeContentType = (editedElementIdx, type) => {
    setContent((content) => {
      const newContent = content.map((el, index) =>  index === editedElementIdx ?
        {contentType: type, value: type.includes('List') ? [`${el.value}`] : el.value}
        :
        el);

      return (newContent);
    });
  };

  const handleChangeContentValue = (editedElementIdx, editedValue) => {
    setContent((content) => content.map((el, index) => index === editedElementIdx ? {...el, value: editedValue} : el));
  };

  const handeleChangeListValue = (elementIndex, rowIndex, value) => {
    const newContentElement = {...content[elementIndex], value: content[elementIndex].value.map((el, idx) => idx === rowIndex ? value : el)};
    const newContent = content.map((el, idx) => idx === elementIndex ? newContentElement : el);

    setContent(newContent);
  };

  const removeRowe = (elementIndex, rowIndex) => {
    const newContentElement = {...content[elementIndex], value: content[elementIndex].value.filter((_, idx) => idx !== rowIndex)};
    const newContent = content.map((el, idx) => idx === elementIndex ? newContentElement : el);

    setContent(newContent);
  };

  const handeleRemoveContent = (elementIndex) => {
    setContent((content) => content.filter((_, idx) => idx !== elementIndex));
  };

  const handeleAddContent = (elementIndex) => {
    setContent((content) => {
      const newContent = content.map((el) => el);

      newContent.splice(elementIndex + 1, 0, {contentType: '', value: ''});
      return (newContent);
    });
  };

  const handleAddRow = (elementIndex) => {
    const newContent = content.map((el, idx) => idx === elementIndex ? {...content[elementIndex], value: [...content[elementIndex].value, '']} : el);

    setContent(newContent);
  };


  return (
    <>
      <Card
        className="p-4 m-4"
        elevation={25}
      >
        <Formik
          initialValues={{
            _id: topic._id || '',
            title: topic.title || '',
            path: topic.path || '',
            category: topic.category?._id || '',
            subCategory: topic.subCategory?._id || '',
          }}
          onSubmit={(values) => {
            const {title, path, category, subCategory} = values;

            if (topic._id) {
              editHelpTopicApi({dispatch, topic: {...values, content}});
            } else {
              addHelpTopicApi({dispatch, helpTopic: {title, path, category, subCategory, content}});
            }

            setTopic(null);
          }}
          validationSchema={
            yup.object({
              title: yup
                .string()
                .required('Field is required'),
              path: yup
                .string()
                .required('Field is required'),
            })
          }
        >
          {({
            values,
            errors,
            touched,
            handleBlur,
            handleChange,
            handleSubmit,
          }) => {
            const filteredSubCategory = values.category ? helpSubCategories.filter((subCategory) => subCategory.category?._id === values.category) : helpSubCategories;
            return (
              <form autoComplete="off" className="p-8" onSubmit={handleSubmit}>
                <Grid container spacing={3} className="p-4">
                  <Grid item xs={12} sm={12} md={12}>
                    <TextField
                      className="w-full mt-10"
                      select
                      fullWidth
                      variant="outlined"
                      name="category"
                      value={values.category}
                      label="Category"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={touched.category && Boolean(errors.category)}
                      helperText={touched.category && errors.category}
                    >
                      {helpCategories.map((category) => <MenuItem key={category._id} value={category._id}>{category.title}</MenuItem>)}
                    </TextField>
                    <TextField
                      className="w-full mt-10"
                      name="subCategory"
                      variant="outlined"
                      fullWidth
                      value={values.subCategory}
                      label="Sub Category"
                      select
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={touched.subCategory && Boolean(errors.subCategory)}
                      helperText={touched.subCategory && errors.subCategory}
                    >
                      {
                        filteredSubCategory.map((subCategory) => <MenuItem key={subCategory._id} value={subCategory._id}>{subCategory.title}</MenuItem>)
                      }
                    </TextField>
                    <TextField
                      required
                      className="w-full mt-10"
                      label="Topic title"
                      name="title"
                      variant="outlined"
                      value={values.title}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={touched.title && Boolean(errors.title)}
                      helperText={touched.title && errors.title}
                    />
                    <TextField
                      required
                      className="w-full mt-10"
                      label="Path"
                      name="path"
                      variant="outlined"
                      value={values.path}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={touched.path && Boolean(errors.path)}
                      helperText={touched.path && errors.path}
                    />
                    <Grid item xs={12} className="mt-10">
                      <Typography variant="h5" className="text-brand m-2">Topic Content</Typography>
                      {content.map((el, index) => (
                        <TopicContent
                          content={el}
                          key={`${index}-${el.contentType}`}
                          elementIndex={index}
                          handleChangeContentValue={handleChangeContentValue}
                          handleChangeContentType={handleChangeContentType}
                          handeleChangeListValue={handeleChangeListValue}
                          removeRowe={removeRowe}
                          handeleRemoveContent={handeleRemoveContent}
                          handeleAddContent={handeleAddContent}
                          handleAddRow={handleAddRow}
                        />
                      ))}
                    </Grid>
                    <div className="flex items-center justify-end mt-8">
                      <Button
                        variant="contained"
                        onClick={() => setTopic(null)}
                      >
                        Cancel
                      </Button>
                      <Button
                        variant="contained"
                        color="primary"
                        className="mx-10"
                        type="submit"
                      >
                        {values._id ? 'Edit Topic' : 'Save Topic'}
                      </Button>
                    </div>
                  </Grid>
                </Grid>
              </form>
            );
          }}
        </Formik>
      </Card>
      <BackdropCircular loading={isLoadingHelpSubCategories} />
    </>
  );
};

export default TopicsForm;
